import React, { useState, useEffect } from "react";
import useHttp from "../../../hook/use-http";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_bus";
import NoData from "./NoData";
import ChartLoader from "./ChartLoader";
import GaugeChart_Bus from "./GaugeChart_Bus";

export default function EnergyAnalyticsPdf(props) {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  let { title, template_id, show, soarting, gloablfilter, IND } = props;

  const [gauge_data, setgauge_data] = useState({});
  const [city, setCity] = useState([]);
  const [city1, setCity1] = useState([]);
  const [airVentilation, setAirVentilation] = useState();
  const [PLValue, setPLValue] = useState();
  const [netCon, setNetCon] = useState();
  const [energyCon, setEnergyCon] = useState();
  const [energyReg, setEnergyReg] = useState();
  const [distanceInKM, setDistanceInKM] = useState();
  const [regFraction, setRegFraction] = useState();
  const [regFactor, setRegFactor] = useState();

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "pdf_bus/three_gauge_chart",
        body: { filterdata: gloablfilter },
      },
      gaugeData
    );
    fetchData(
      {
        url: API_URL_MAIN + "pdf_bus/energytable1",
        body: { filterdata: gloablfilter },
      },
      tablecountfunc1
    );
    fetchData(
      {
        url: API_URL_MAIN + "pdf_bus/energytable2",
        body: { filterdata: gloablfilter },
      },
      tablecountfunc2
    );
  }, [gloablfilter]);

  const gaugeData = (data) => {
    setgauge_data({
      dataNet_kWh: data[0].dataNet_kWh.value / data[0].distanceInKM.value,
      dataCons_kWh: data[0].dataCons_kWh.value / data[0].distanceInKM.value,
      dataRegen_kWh: data[0].dataRegen_kWh.value / data[0].distanceInKM.value,
    });
  };

  const tablecountfunc1 = (data) => {
    setCity(data.uniqueCities);
    setAirVentilation(data.airVent);
    setPLValue(data.PLval);
    setNetCon(data.netConsumption);
    setEnergyCon(data.energyConsumption);
    setEnergyReg(data.energyRegenerated);
    setDistanceInKM(data.distanceInKM);
  };
  const tablecountfunc2 = (data) => {
    setCity1(data.uniqueCities);
    // setAirVentilation(data.airVent);
    // setPLValue(data.PLval);
    // setNetCon(data.netConsumption);
    // setEnergyCon(data.energyConsumption);
    setRegFraction(data.regen_kWh);
    setRegFactor(data.cons_kWh);
  };

  return (
    <div className="energypage">
      <div className="row" style={{ justifyContent: "end" }}>
        <img
          src="../../../assets/img_Bus/Pdf_Page/Tatamotors.png"
          alt=""
          style={{ height: "80px", width: "250px" }}
        />
      </div>
      <div className="row mt-3">
        <div className="col-md-6">
          <span
            className="text-left"
            style={{
              fontSize: "20px",
              fontWeight: "bold",
              color: "#002060",
              paddingLeft: "30px",
            }}
          >
            Energy Analytics:{" "}
          </span>
          <span
            className="text-right"
            style={{ color: "#002060", fontSize: "12px" }}
          >
            {props.startdate} - {props.enddate}
          </span>
        </div>
      </div>

      <div className="row ml-0 mt-4 pt-2" id={"energy-title"}>
        <div className="col-md-1"></div>
        <div className="col-md-10" style={{ boxShadow: "0px 0px 3px " }}>
          <div
            className="row"
            style={{
              backgroundColor: "#03045E",
              display: "flex",
              justifyContent: "center",
              color: "#fff",
              padding: "6px 0px",
            }}
          >
            Summary of Fleet
          </div>
        </div>
      </div>

      <div className="row ml-0 mt-2" id={"gauge_collection"}>
        <div className="col-md-1"></div>
        <div className="col-md-10" style={{ boxShadow: "0px 0px 3px " }}>
          <div
            className="row pt-2 pb-2 text-center"
            style={{ backgroundColor: "#E0E0E0" }}
          >
            <div className="col-md-4 col-sm-4 col-lg-4">
              <b className="">Net Consumption</b>
            </div>
            <div
              className="col-md-4 col-sm-4 col-lg-4 pr-0"
              style={{ position: "relative" }}
            >
              <b
                style={{
                  position: "absolute",
                  top: "0",
                  left: "0",
                  paddingBottom: "5px",
                }}
              >
                =
              </b>
              <b className="">Energy Consumption</b>
            </div>
            <div
              className="col-md-4 col-sm-4 col-lg-4 pr-0"
              style={{ position: "relative" }}
            >
              <b
                style={{
                  position: "absolute",
                  top: "0",
                  left: "0",
                  paddingBottom: "5px",
                }}
              >
                -
              </b>
              <b className="">Energy Regenerated</b>
            </div>
          </div>

          <div className="row" style={{ backgroundColor: "white" }}>
            <div className="col-md-4 col-sm-12 col-lg-4">
              <GaugeChart_Bus
                range_end={2}
                range_main={gauge_data.dataNet_kWh}
                title="Net Consumption"
                gauge_color={"#83A4CF"}
              />
            </div>
            <div className="col-md-4 col-sm-12 col-lg-4">
              <GaugeChart_Bus
                range_end={2}
                range_main={gauge_data.dataCons_kWh}
                title="Energy Consumption"
                gauge_color={"#83A4CF"}
              />
            </div>
            <div className="col-md-4 col-sm-12 col-lg-4">
              <GaugeChart_Bus
                range_end={1}
                range_main={gauge_data.dataRegen_kWh}
                title="Energy Regenerated"
                gauge_color={"#83A4CF"}
              />
            </div>
          </div>
        </div>
      </div>

      <div
        className="row mt-3"
        style={{ marginLeft: "20px", marginRight: "20px" }}
      >
        {isLoading ? (
          <ChartLoader />
        ) : Object.keys(city).length > 0 && Object.keys(city1).length > 0 ? (
          <>
            <table
              className="pdftable"
              style={{ color: "black" }}
              id={"energy-table"}
            >
              <tr style={{ backgroundColor: "#c2d2e7" }}>
                <th></th>
                {city.map((cityName, index) => (
                  <th key={index}>{cityName}</th>
                ))}
              </tr>

              <tr style={{ backgroundColor: "#c2d2e7" }}>
                <td>Vehicle Type</td>
                {PLValue.map((cityName, index) => {
                  const value = PLValue[index];
                  const stringValue =
                    typeof value === "string" ? value : String(value || "");
                  // Extract numeric values using regular expression
                  const numericValue =
                    stringValue.match(/[\d/]+/g)?.join("") || "";
                  return <td key={index}>{numericValue}</td>;
                })}
              </tr>

              {/* <tr style={{ backgroundColor: "#e2f0d9" }}>
                <td>Energy Analytics</td>
                {PLValue.map((cityName, index) => (
                  <td key={index}>{airVentilation[cityName]}</td>
                ))}
              </tr> */}

              <tr>
                <td>Net Consumption, Kwh/km</td>
                {PLValue.map((cityName, index) => (
                  <td key={index}>
                    {(netCon[cityName] / distanceInKM[cityName]).toFixed(3)}{" "}
                    Kwh/km
                  </td>
                ))}
              </tr>
              <tr>
                <td>Energy Consumption, Kwh/km</td>
                {PLValue.map((cityName, index) => (
                  <td key={index}>
                    {(energyCon[cityName] / distanceInKM[cityName]).toFixed(3)}{" "}
                    Kwh/km
                  </td>
                ))}
              </tr>
              <tr>
                <td>Energy Regenerated, Kwh/km</td>
                {PLValue.map((cityName, index) => (
                  <td key={index}>
                    {(energyReg[cityName] / distanceInKM[cityName]).toFixed(3)}{" "}
                    Kwh/km
                  </td>
                ))}
              </tr>
              <tr>
                <td>Regeneration Fraction</td>
                {PLValue.map((cityName, index) => (
                  <td key={index}>
                    {(
                      (regFraction[cityName] / regFactor[cityName]) *
                      100
                    ).toFixed(2)}{" "}
                    %
                  </td>
                ))}
              </tr>
              <tr>
                <td>Regeneration Factor Wh/km</td>
                {PLValue.map((cityName, index) => (
                  <td key={index}>
                    {(
                      (regFraction[cityName] / distanceInKM[cityName]) *
                      1000
                    ).toFixed(2)}{" "}
                    Wh/km
                  </td>
                ))}
              </tr>
            </table>
          </>
        ) : (
          <NoData />
        )}
      </div>

      <div className="row bottomcontent pl-4" style={{ paddingTop: "200px" }}>
        <div className="col-md-3">
          <img
            src="../../../assets/img_Bus/Pdf_Page/footer.png"
            alt=""
            style={{ height: "70px", width: "200px" }}
          />
        </div>
        <div className="col-md-1"></div>
        <div className="col-md-4">
          <p
            style={{
              fontSize: "11px",
              paddingTop: "60px",
              paddingLeft: "10px",
            }}
          >
            Copyright, Confidential, Tata Motors Limited
          </p>
        </div>
      </div>
    </div>
  );
}
